module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.11d32281.svg";